import { Dispatch, SetStateAction, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Typography,
} from '@mui/material';
import CustomButton from '../../../../../../components/button/CustomButton';

export type DisplayLinkProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  link: string;
};

const DisplayLink = ({ isOpen, setIsOpen, link }: DisplayLinkProps) => {
  const [copyTooltipDisplay, setCopyTooltipDisplay] = useState(false);
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">Review Link</DialogTitle>
      <DialogContent
        dividers
        sx={{
          overflow: 'scroll',
        }}
      >
        {/* <DialogContentText id="alert-dialog-description"> {link} </DialogContentText> */}
        <Tooltip
          title="Copied!"
          open={copyTooltipDisplay}
          placement="top"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 25],
                  },
                },
              ],
            },
          }}
        >
          <Typography variant="body3" sx={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
            {link}
          </Typography>
        </Tooltip>
      </DialogContent>
      <DialogActions>
        <CustomButton
          sx={{ marginRight: '30px' }}
          variant="primaryText"
          onClick={() => {
            setCopyTooltipDisplay(true);
            navigator.clipboard.writeText(link);
            setTimeout(() => {
              setCopyTooltipDisplay(false);
            }, 1000);
          }}
        >
          Copy
        </CustomButton>
        <CustomButton
          sx={{ marginRight: '10px' }}
          variant="primaryText"
          onClick={() => setIsOpen(false)}
        >
          Close
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DisplayLink;
